/**
 * A ProForma form with everything: supports all features in ProForma.
 */

/**
 * A ProForma form that cannot be filled out.  It serves as a template for forms that can be filled out, and is typically
 * copied onto Jira issues where it can be filled out.
 */

/**
 * A ProForma form that can be previewed.
 */

/**
 * A ProForma form that can be filled out.
 */

/**
 * Configures how this form is published (if it is published somewhere).
 * Used only on template forms, not available on forms.
 */

/**
 * Configures how this form is published within Jira.
 * Used only on template forms, not available on forms.
 */

/**
 * Configures how this form is published on the Jira Service Desk portal.
 * Used only on template forms, not available on forms.
 */

export const defaultFormPublishing = {
  submitOnCreate: true,
  validateOnCreate: true
};

/**
 * The design of the form: the static parts that don't change when filled in such as questions, sections and layout.
 */

/**
 * The state of the form: the dynamic parts that people change when filling in a form.
 * Optional property, it is not available on template forms.
 */

/**
 * General form settings, ie those which affect the entire form.
 * Other settings are applied at the section or question level.
 */

/**
 * Settings specific to the Jira Service Desk portal. Not applicable when JSD is not installed.
 */

/**
 * Settings controlling what happens on submit of this form.
 */

/**
 * Visual layout of the form, ie a document containing the structure and layout of where the sections and questions appear on the form.
 * This is an ADF (Atlassian Document Format) document.
 */

/**
 * Conditions applied to sections, questions and choices which may change the visibility of those items.
 */

/**
 * Base interface for a condition. Different types of conditions extend this to provide type-specific configuration
 * of the condition.
 */

/**
 * The input into a condition which defines whether or not the condition is triggered.
 */

/**
 * A form condition input which is fulfilled when the answer to a choice question includes any one of the choices nominated in `cIds`.
 */

/**
 * Condition output describes what items the condition affects when it is triggered: choices, questions, sections or the whole form.
 * Which items may be affected will depend on the condition type.
 */

export function isShowCondition(c) {
  // eslint-disable-next-line @typescript-eslint/no-use-before-define
  return c.t === FormConditionType.Show;
}

/**
 * Show condition: hides and shows a section or question based on choices made in a previous question.
 */

/**
 * Sections of the form, used to apply conditions to more of the form than just a single question.
 */

/**
 * A single section of a form.
 */

/**
 * Questions on the form.
 */

/**
 * A single question on a form.
 */

/**
 * A choice on a choice question.
 */

/**
 * Form question validation configuration.
 */

/**
 * The answers to questions on a form.
 *
 * Answers will only be populated when someone fills out a form; if the form has not been filled out then the
 * answers object may be empty. It is also possible for the answers object to be partially populated: some but
 * not all answers listed. However there should not a situation where there is an answer which does not have a
 * matching question in the form questions object.
 */

/**
 * Answer to a single question on a form.
 * Can also be used to define the default answer to a question.
 */

/**
 * Instance of a FormAnswer object without any answer.
 */
export const FormAnswerEmpty = {};

/**
 * A user selected in a user picker.
 */

/** A string in ISO 8601 date and time format, in UTC timezone. */

/** A string in ISO 8601 date format with no timezone. */

/** A string in ISO 8601 time format with no timezone. */

/**
 * The visibility of a form, which may be internal or external.
 */
export let FormVisibility = /*#__PURE__*/function (FormVisibility) {
  /**
   * Internal form: in the context of Jira Service Desk this means the form only appears inside Jira and not on the Jira Service Desk portal.
   * In other contexts like template forms and Jira Software the meaning is undefined.
   */
  FormVisibility["Internal"] = "i";
  /**
   * External form: in the context of Jira Service Desk this means the form appears both in Jira and on the Jira Service Desk portal.
   * In other contexts like template forms and Jira Software the meaning is undefined.
   */
  FormVisibility["External"] = "e";
  return FormVisibility;
}({});
export let FormStatus = /*#__PURE__*/function (FormStatus) {
  FormStatus["Open"] = "o";
  FormStatus["Submitted"] = "s";
  FormStatus["Locked"] = "l";
  return FormStatus;
}({});
export let FormConditionType = /*#__PURE__*/function (FormConditionType) {
  FormConditionType["Show"] = "sh";
  return FormConditionType;
}({});
export let FormSectionType = /*#__PURE__*/function (FormSectionType) {
  FormSectionType["Block"] = "b";
  FormSectionType["Page"] = "p";
  return FormSectionType;
}({});
export let FormQuestionType = /*#__PURE__*/function (FormQuestionType) {
  FormQuestionType["Attachment"] = "at";
  FormQuestionType["ChoiceCascading"] = "cc";
  FormQuestionType["ChoiceDropdown"] = "cd";
  FormQuestionType["ChoiceDropdownMultiple"] = "cl";
  FormQuestionType["ChoiceMultiple"] = "cm";
  FormQuestionType["ChoiceSingle"] = "cs";
  FormQuestionType["CmdbObject"] = "ob";
  FormQuestionType["Date"] = "da";
  FormQuestionType["DateTime"] = "dt";
  FormQuestionType["Number"] = "no";
  FormQuestionType["TextEmail"] = "te";
  FormQuestionType["TextLong"] = "tl";
  FormQuestionType["TextParagraph"] = "pg";
  FormQuestionType["RichTextParagraph"] = "rt";
  FormQuestionType["TextShort"] = "ts";
  FormQuestionType["TextUrl"] = "tu";
  FormQuestionType["Time"] = "ti";
  FormQuestionType["UserMultiple"] = "um";
  FormQuestionType["UserSingle"] = "us";
  return FormQuestionType;
}({});